import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HeaderContainer,
  Container,
  HeaderContent,
  Logo,
  Tagline,
  Nav,
  NavList,
  NavItem,
  NavLink,
  HeaderActions,
  PhoneBtn,
  PhoneIcon,
  PhoneText,
  MenuToggle
} from './Header.styles.jsx';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isHomePage = location.pathname === '/';

  return (
    <HeaderContainer>
      <Container>
        <HeaderContent>
          <Logo>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h1>Instalații Pro</h1>
              <Tagline>Servicii Profesionale</Tagline>
            </Link>
          </Logo>
          
          <Nav isOpen={isMenuOpen}>
            <NavList>
              {isHomePage ? (
                <>
                  <NavItem>
                    <NavLink href="#servicii" isMobile={true} onClick={closeMenu}>Servicii</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="#despre" isMobile={true} onClick={closeMenu}>Despre Noi</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="#galerie" isMobile={true} onClick={closeMenu}>Galerie</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="#contact" isMobile={true} onClick={closeMenu}>Contact</NavLink>
                  </NavItem>
                </>
              ) : (
                <>
                  <NavItem>
                    <NavLink as={Link} to="/" isMobile={true} onClick={closeMenu}>Acasă</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink as={Link} to="/#servicii" isMobile={true} onClick={closeMenu}>Servicii</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink as={Link} to="/#despre" isMobile={true} onClick={closeMenu}>Despre Noi</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink as={Link} to="/#galerie" isMobile={true} onClick={closeMenu}>Galerie</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink as={Link} to="/#contact" isMobile={true} onClick={closeMenu}>Contact</NavLink>
                  </NavItem>
                </>
              )}
              <NavItem>
                <NavLink as={Link} to="/blog" isMobile={true} onClick={closeMenu}>Blog</NavLink>
              </NavItem>
            </NavList>
          </Nav>

          <HeaderActions>
            <PhoneBtn href="tel:+40721150463" title="Sună: +40721150463">
              <PhoneIcon>📞</PhoneIcon>
              <PhoneText>+40721150463</PhoneText>
            </PhoneBtn>
            
            <MenuToggle 
              isOpen={isMenuOpen}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </MenuToggle>
          </HeaderActions>
        </HeaderContent>
      </Container>
    </HeaderContainer>
  );
};

export default Header;

